import { set } from '@/utils'

const initialState = () => {
  return {
    firstName: '',
    lastName: '',
    email: '',
    id: '',
    roles: []
  }
}

const state = initialState()

const modules = {}

const getters = {
  /**
   * Determine if the user is logged in (if id is present)
   * @returns {boolean}
   */
  isUserAuthenticated: state => Boolean(state.id),

  fullName: state => `${state.firstName} ${state.lastName}`,
  email: state => state.email,
  roles: state => state.roles,
  userId: state => state.id
}

const mutations = {
  /**
   * Set the current user and validate photo url
   * @param state
   * @param user
   */
  setUser: (state, user) => {
    set(state, user)
  },

  setSingleProperty: (state, [prop, value]) => {
    state[prop] = value
  }
}

const actions = {
  /**
   * Set the logged in user data AND
   * determine their site access level based on their doorman role
   * @param commit
   * @param user
   */
  setUser({ commit }, user) {
    commit('setUser', user)
  },

  setEmail({ commit }, email) {
    commit('setSingleProperty', ['email', email])
  },

  /**
   * Clear the current user and user access
   * @param commit
   * @returns {Promise<void>}
   */
  async clearUser({ commit }) {
    const resetState = await initialState()
    commit('setUser', resetState)
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
  modules
}
